import React from 'react';
import { uiColors } from '@leafygreen-ui/palette';

export const vegaDarkTheme = {
  text: {
    fill: uiColors.gray.light3, // Data points / Text Value
  },
  style: {
    'guide-title': {
      fill: uiColors.gray.light3, // Channel labels
    },
    cell: {
      zindex: 2,
      stroke: uiColors.gray.dark2,
    },
  },
  axis: {
    gridColor: uiColors.gray.dark2, // Grid lines
    domainColor: uiColors.gray.base, // Axis
    tickColor: uiColors.gray.base, // Axis ticks
    labelColor: uiColors.gray.light3, // Axis labels
  },
  legend: {
    labelColor: uiColors.gray.light3, // Legend values color
  },
};

export const ThemeContext = React.createContext('light');
export const useTheme = () => React.useContext(ThemeContext);
